import { MessageDesignTokens } from '@primeuix/themes/aura/message';

export const messageTokens: MessageDesignTokens = {
  root: {
    borderRadius: '{content.border.radius}',
    borderWidth: '1px',
    transitionDuration: '{transition.duration}',
  },
  content: {
    padding: '0.4rem 0.75rem',
    gap: '0.57rem',
    sm: {
      padding: '0.375rem 0.625rem',
    },
    lg: {
      padding: '0.625rem 0.875rem',
    },
  },
  text: {
    fontSize: '1rem',
    fontWeight: '500',
    sm: {
      fontSize: '0.875rem',
    },
    lg: {
      fontSize: '1.125rem',
    },
  },
  icon: {
    size: '0.875rem',
    sm: {
      size: '0.75rem',
    },
    lg: {
      size: '1rem',
    },
  },
  closeButton: {
    width: '1.75rem',
    height: '1.75rem',
    borderRadius: '{message.close.button.width} / 2',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      offset: '{focus.ring.offset}',
    },
  },
  closeIcon: {
    size: '1rem',
    sm: {
      size: '0.875rem',
    },
    lg: {
      size: '1.125rem',
    },
  },
  outlined: {
    root: {
      borderWidth: '1px',
    },
  },
  simple: {
    content: {
      padding: '0',
    },
  },
  colorScheme: {
    light: {
      info: {
        background: '{violet.50}',
        borderColor: '{violet.600}',
        color: '{violet.600}',
        shadow: '0 4px 8px 0 rgba(2, 5, 10, 0.04)',
        closeButton: {
          hoverBackground: '{violet.800}',
          focusRing: {
            color: '{violet.800}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{violet.600}',
          borderColor: '{violet.600}',
        },
        simple: {
          color: '{violet.600}',
        },
      },
      success: {
        background: '{green.50}',
        borderColor: '{green.600}',
        color: '{green.600}',
        shadow: '0 4px 8px 0 rgba(1, 9, 2, 0.04)',
        closeButton: {
          hoverBackground: '{green.800}',
          focusRing: {
            color: '{green.800}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{green.600}',
          borderColor: '{green.600}',
        },
        simple: {
          color: '{green.600}',
        },
      },
      warn: {
        background: '{orange.50}',
        borderColor: '{orange.600}',
        color: '{orange.600}',
        shadow: '0 4px 8px 0 rgba(9, 7, 0, 0.04)',
        closeButton: {
          hoverBackground: '{orange.800}',
          focusRing: {
            color: '{orange.800}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{orange.600}',
          borderColor: '{orange.600}',
        },
        simple: {
          color: '{orange.600}',
        },
      },
      error: {
        background: '{red.50}',
        borderColor: '{red.600}',
        color: '{red.600}',
        shadow: '0 4px 8px 0 rgba(10, 3, 3, 0.04)',
        closeButton: {
          hoverBackground: '{red.600}',
          focusRing: {
            color: '{red.600}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{red.600}',
          borderColor: '{red.600}',
        },
        simple: {
          color: '{red.600}',
        },
      },
      secondary: {
        background: '{surface.100}',
        borderColor: '{surface.200}',
        color: '{surface.600}',
        shadow: '0 4px 8px 0 rgba(4, 5, 6, 0.04)',
        closeButton: {
          hoverBackground: '{surface.200}',
          focusRing: {
            color: '{surface.600}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{surface.500}',
          borderColor: '{surface.500}',
        },
        simple: {
          color: '{surface.500}',
        },
      },
      contrast: {
        background: '{surface.900}',
        borderColor: '{surface.950}',
        color: '{surface.50}',
        shadow: '0 4px 8px 0 rgba(0, 0, 1, 0.04)',
        closeButton: {
          hoverBackground: '{surface.800}',
          focusRing: {
            color: '{surface.50}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{surface.950}',
          borderColor: '{surface.950}',
        },
        simple: {
          color: '{surface.950}',
        },
      },
    },
    dark: {
      info: {
        background: '{violet.900}',
        borderColor: '{violet.200}',
        color: '{violet.200}',
        shadow: '0 4px 8px 0 rgba(2, 5, 10, 0.04)',
        closeButton: {
          hoverBackground: 'rgba(255, 255, 255, 0.05)',
          focusRing: {
            color: '{violet.200}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{violet.200}',
          borderColor: '{violet.200}',
        },
        simple: {
          color: '{violet.200}',
        },
      },
      success: {
        background: '{green.900}',
        borderColor: '{green.300}',
        color: '{green.300}',
        shadow: '0 4px 8px 0 rgba(1, 9, 2, 0.04)',
        closeButton: {
          hoverBackground: 'rgba(255, 255, 255, 0.05)',
          focusRing: {
            color: '{green.300}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{green.300}',
          borderColor: '{green.300}',
        },
        simple: {
          color: '{green.300}',
        },
      },
      warn: {
        background: '{orange.900}',
        borderColor: '{orange.300}',
        color: '{orange.300}',
        shadow: '0 4px 8px 0 rgba(9, 7, 0, 0.04)',
        closeButton: {
          hoverBackground: 'rgba(255, 255, 255, 0.05)',
          focusRing: {
            color: '{orange.300}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{orange.300}',
          borderColor: '{orange.300}',
        },
        simple: {
          color: '{orange.300}',
        },
      },
      error: {
        background: '{red.900}',
        borderColor: '{red.300}',
        color: '{red.300}',
        shadow: '0 4px 8px 0 rgba(10, 3, 3, 0.04)',
        closeButton: {
          hoverBackground: 'rgba(255, 255, 255, 0.05)',
          focusRing: {
            color: '{red.300}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{red.300}',
          borderColor: '{red.300}',
        },
        simple: {
          color: '{red.300}',
        },
      },
      secondary: {
        background: '{surface.800}',
        borderColor: '{surface.700}',
        color: '{surface.300}',
        shadow: '0 4px 8px 0 rgba(4, 5, 6, 0.04)',
        closeButton: {
          hoverBackground: '{surface.700}',
          focusRing: {
            color: '{surface.300}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{surface.400}',
          borderColor: '{surface.400}',
        },
        simple: {
          color: '{surface.400}',
        },
      },
      contrast: {
        background: '{surface.0}',
        borderColor: '{surface.100}',
        color: '{surface.950}',
        shadow: '0 4px 8px 0 rgba(0, 0, 1, 0.04)',
        closeButton: {
          hoverBackground: '{surface.100}',
          focusRing: {
            color: '{surface.950}',
            shadow: 'none',
          },
        },
        outlined: {
          color: '{surface.0}',
          borderColor: '{surface.0}',
        },
        simple: {
          color: '{surface.0}',
        },
      },
    },
  },
};
